import createSimplePrivateGallery from '@PROJECT_ROOT/assets/desktop/js/search/simplePrivateGallery';

const compareTable = {
	params: {},
	init: function(config) {
		var self = this;
		self.params = config;

		initGalleries(self.params.unitGalleries);
		self.updateSS();
		self.initSort();
		self.makeDragable(self.params.table);
		self.initCalendars(self.params.calendarStartDate, self.params.calendarURL);
		self.initUserSort();

	},
	updateSS: function() {
		// Check if units stored in localStorage still exist in compare list. If not, delete them from localStorage
		var self = this;
		if(self.params.storageUnits != null) {
			var unitID;
			$.each(self.params.storageUnits, function(index, value) {
				unitID = index.replace('move', '');	// trim "move1234" to "1234"
				if (unitID != 'firstCol' && self.params.compareUnits[unitID] === undefined) {
					delete self.params.storageUnits[index];
				}
			});

			window.localStorage.setItem('tableorder', JSON.stringify(self.params.storageUnits));
		}
	},
	initSort: function() {
		// Sort the units in increasing order exp. "move16002":2,"move3896":1,"move18106":3," => "move3896":1,"move16002":2,"move18106":3,"
		var self = this;
		if (window.localStorage.getItem('tableorder') != '') {
			var startOrder = JSON.parse(window.localStorage.getItem('tableorder')),
				sortable = [];
			for (var unit in startOrder) sortable.push([unit, startOrder[unit]]);
			sortable.sort(function(a, b) {return a[1] - b[1];});
			startOrder = {};
			$(sortable).each(function(index, item) {
				startOrder[item[0]]=index;
			});
			window.localStorage.setItem('tableorder',JSON.stringify(startOrder));
		}
		else {
			window.localStorage.setItem('tableorder', '{}');
		}
	},
	makeDragable: function($table) {
		//plugin: jquery.dragtable.js
		var self = this;
		$table.dragtable({
			revert: true,
			dragaccept: '.dragCol',
			dragHandle: '.moveHandler',
			beforeStart: function(table) {
				$table.addClass('disableSelect');
				$table.find('.compareCalendarWrap').hide();
				$table.find('.compareCalendar').html('<div class="loader32w" style="display: block;"></div>');
			},
			beforeStop: function(table) {
				$table.removeClass('disableSelect');
				var sel = window.getSelection ? window.getSelection() : document.selection;
				if (sel) {
					if (sel.removeAllRanges) {
						sel.removeAllRanges();
					} else if (sel.empty) {
						sel.empty();
					}
				}
				window.localStorage.setItem('sorttype', 'standard');
				self.markActiveSort(self.params.$sortList.find('[data-value=standard]'));
			},
			persistState: function(table) {
				if (!window.localStorage) return;
				table.sortOrder['firstCol']=0;
				table.el.find('.moveHandler').each(function(i) {
					if (this.id != '') {
						table.sortOrder[this.id]=i+1;
					}
				});
				window.localStorage.setItem('tableorder',JSON.stringify(table.sortOrder));
			},
			restoreState: JSON.parse(window.localStorage.getItem('tableorder'))
		}).on('click', 'tr', function(e) {
			$(this).toggleClass('highlighted');
		});
	},
	initCalendars: function(calendarStartDate, calendarURL) {
		var self = this;

		self.params.table.on('click', '.showCompareCalendar', function(e) {
			var tdCalendar = $(this).parent();

			self.params.table.find('.compareCalendarWrap').hide();
			tdCalendar.find('.compareCalendarWrap').show();
			$.ajax({
				url: calendarURL,
				type: 'POST',
				data: 'unit_id=' + $(this).data('unit_id') + '&date='+ calendarStartDate +'&type=dynamic',
				context: tdCalendar.find('.compareCalendarWrap'),
				success: function(data) {
					$(this).find('.compareCalendar').html(data);
				}
			});
		}).on('click', '.closeCompareCalendar', function(e) {
			$(this).parent('.compareCalendarWrap').hide();
		});
	},
	initUserSort: function() {
		var self = this;

		self.params.rows = self.params.table.find('tr');
		self.params.dragtable = self.params.table.data('dragtable');

		self.params.$sortList.on('click', '.sortTrigger', function() {
			var that = $(this),
				sorted = false;

			sorted = self.sortBy(that.data('value'));

			if (sorted === true) {
				self.markActiveSort(that);
        		$('.sortResults ul').toggle(200);
			} else {
				$('#alertWindow').clone().removeClass('hide').dialog( {
					modal: true,
					title: self.params.noPricesDialog,
					draggable: false,
					resizable: false,
					buttons: {
						"OK": function() {
							$(this).dialog('close');
						}
					}
				});
			}

		});

		var initSortType = window.localStorage.getItem('sorttype');
		// sort 'auto' je obsolete; potrebno podržati radi mogućeg postojanja stare vrijednosti u local storage-u
		if (initSortType && initSortType !== 'auto' && initSortType !== 'standard') {
			var sorted = self.sortBy(initSortType);
			if (sorted === true) {
				self.markActiveSort(self.params.$sortList.find('[data-value='+initSortType+']'));
			}
		}

		$(document).on('click', self.params.sortSelected, function (e) {
            $('.sortResults ul').toggle(200);
        });

	},
	markActiveSort: function(el) {
		var self = this;
		$(self.params.sortSelected).replaceWith($(el).clone().removeClass('sortTrigger'));
		self.params.$sortList.find('.sortTrigger').removeClass('active');
		el.addClass('active');
		self.params.rows.removeClass('highlighted');
		if (el.data('value') != 'standard') {
			self.params.row[el.data('value')].addClass('highlighted');
		}
	},
	sortBy: function(sortType) {
		var self = this;
		if (sortType=='price' && self.params.row['price'].hasClass('noPrices')) {
			return false;
		}

		var sortable = [],
			tableOrder = {};

		self.params.row[sortType].find('.sortByField').each(function(i, el) {
			sortable.push(['move'+$(el).data('unitid'), $(el).data('value')]);
		});
		sortable.sort(function(a, b) {return a[1] - b[1];});
		tableOrder['firstCol']=0;
		$(sortable).each(function(index, item) {
			tableOrder[item[0]]=index+1;
		});
		self.params.dragtable._restoreState(tableOrder);
		window.localStorage.setItem('tableorder',JSON.stringify(tableOrder));

		window.localStorage.setItem('sorttype', sortType);

		return true;
	}
};

function initGalleries(galleryWrappers) {
	galleryWrappers.forEach((wrapper) => {
		const images = JSON.parse(wrapper.getAttribute('data-images'));
		const galleryContainer = wrapper.querySelector('.compareUnitGallery');
        createSimplePrivateGallery({
            source: images,
            nextButton: galleryContainer.querySelector('.simpleGalleryNext'),
            previousButton: galleryContainer.querySelector('.simpleGalleryPrev'),
            counterElement: galleryContainer.querySelector('.simpleGalleryCounter'),
            imageElement: galleryContainer.querySelector('.currentImage img'),
            imageDescription: galleryContainer.querySelector('figcaption'),
            galleryHeight: galleryContainer.style.height,
            toggleImageDescription: true,
        });
	});
}

export default compareTable;
